angular.module('tgaAdmin').controller('NavigationController', [
  '$scope',
  '$rootScope',
  '$state',
  '$filter',
  '$window',
  'envService',
  'domainService',
  'userService',
  'gameService',
  'settingsService',
  'modalService',
  'activityService',
  'hubService',
  'notificationService',
  'stateHistoryService',
  'rootScopeCacheService',
  '$location',
  function (
    $scope,
    $rootScope,
    $state,
    $filter,
    $window,
    envService,
    domainService,
    userService,
    gameService,
    settingsService,
    modalService,
    activityService,
    hubService,
    notificationService,
    stateHistoryService,
    rootScopeCacheService,
    $location,
  ) {
    $scope.$state = $state;

    $scope.data = {
      gameTypes: gameService.getGameTypes(),
      hasNewGame: gameService.getGameTypes().find((game) => game.new === true),
      games: [],
      activities: [],
      settings: {},
      isAdmin: userService.checkUserType(['admin', 'super_admin', 'sales_admin', 'support_admin']),
      isEditor: userService.checkUserType(['editor', 'creator_admin']),
      isSuperAdmin: userService.checkUserType(['super_admin']),
      isSupportAdmin: userService.checkUserType(['support_admin']),
      isSalesAdmin: userService.checkUserType(['sales_admin']),
      isViewerAdmin: userService.checkUserType(['viewer_admin']),
      isSSO: true,
      logo: '',
      defaultLogo: './v1/assets/images/logo-white.svg',
      arcadesLogo: './v1/assets/images/arcade/logo/Arcades_Icon_Red.svg',
      enableEvents: envService.read('enableEvents'),
      currentGame: gameService.currentGame(),
      currentHub: hubService.currentHub(),
      environment: envService.get(),
      arcadesEnabled: false,
    };

    $scope.viewmodel = {
      game_id: gameService.currentGame().game_id,
    };

    $scope.$watch(gameService.currentGame, () => {
      $scope.viewmodel.game_id = gameService.currentGame().game_id;
      $scope.data.currentGame = gameService.currentGame();

      if ($scope.data.currentGame.game_type) {
        const matchedType = $filter('filter')($scope.data.gameTypes, { key: $scope.data.currentGame.game_type }, true);
        if (matchedType && matchedType.length) {
          $scope.data.currentGame.game_type_name = matchedType[0].name;
        }
      }
    });

    const URLprefix = $scope.data.environment === 'development' ? '' : '/admin';

    const resizeHandler = () => {
      if ($window.innerWidth > 992) {
        $('#aside').modal('hide'); // Disable modal
      }
    };

    $scope.$watch(hubService.currentHub, () => {
      $scope.data.currentHub = hubService.currentHub();
    });

    $scope.initialize = function () {
      $scope.getPermissions();
      $scope.getActivities();
      $scope.getSettings();
      angular.element($window).on('resize', resizeHandler);
      notificationService.poll();

      // If we visit any V1 route that has Nav with `?newGamePopup` then automatically trigger the popup.
      if ($state.$current.data.nav && $location.search().newGamePopup) {
        $scope.actions.presentGame();
      }
    };

    $scope.getPermissions = function () {
      domainService.getPermissions().then(() => {
        for (let i = 0; i < $scope.data.gameTypes.length; i++) {
          if (!domainService.hasPermission('game', $scope.data.gameTypes[i].key)) {
            $scope.data.gameTypes[i].disabled = true;
          }
        }
        if (domainService.hasPermission('addon', 'arcades')) {
          $scope.data.arcadesEnabled = true;
        }
      });
    };

    $scope.getSettings = function () {
      settingsService.getSettings().then((settings) => {
        if (settings.logo) {
          $scope.data.logo = settings.logo;
        } else {
          $scope.data.logo = $scope.data.defaultLogo;
        }

        $scope.data.isSSO = settings.is_sso;
        $scope.data.settings = settings;
      });
    };

    $scope.getActivities = function () {
      activityService.getActivities().then((activities) => {
        $scope.data.activities = activities;
      });
    };

    // determine if game "back" nav button should go to 'games' or 'instructorList'
    // read previous state history in order to determine this
    $scope.determineBackLocation = function () {
      const history = stateHistoryService.get();
      let last = 'v1.games';
      for (let i = history.length - 1; i > -1; i--) {
        if (history[i] === 'v1.instructorList' || history[i] === 'v1.games') {
          last = history[i];
          break;
        }
      }
      return $state.href(last);
    };

    $scope.checkDirtyGameForm = function () {
      const gameControllerScope = rootScopeCacheService.get('GameControllerScope');
      if (gameControllerScope) {
        return gameControllerScope.gameForm.$dirty;
      }
      return false;
    };

    $scope.actions = {
      presentGame() {
        const defaults = {
          backdrop: true,
          keyboard: true,
          animation: true,
          templateUrl: 'templates/partials/game/game_selection_modal.html',
          size: null,
        };

        const options = {
          title: 'Select a Game Type',
          message: 'Which type of game do you want to create?',
          closeButton: 'Cancel',
          actionButton: 'Select',
          //TODO: remove filter once category quest is complete
          gameTypes: $scope.data.gameTypes,
        };

        modalService
          .showModal(options, defaults)
          .then((key) => {
            const matchedType = $filter('filter')($scope.data.gameTypes, { key }, true);
            if (matchedType.length && matchedType[0].disabled) {
              $state.go('v1.account', {
                type: key,
                tab: 'subscriptions',
              });
            } else {
              // TODO: Currently not showing selection for Trivia on prod
              if (
                key === 'category_quest' ||
                key === 'noodle' ||
                (key === 'trivia' && $scope.data.environment !== 'production')
              ) {
                singleSpaNavigate(`${URLprefix}/v2/game/add/${key}`);
                return;
              }
              // reset the viewmodel and data state params in case you
              // just copied a game right before doing it this way
              $state.go('v1.addGame', {
                type: key,
                viewmodel: null,
                data: null,
              });
            }
          })
          .catch(angular.noop);

        $('#aside').modal('hide'); // Hide slideout nav
      },
      launchGame() {
        const gameMode = $scope.data.currentGame.game_mode;
        const isInstructorLeadOrInitiated = gameMode === 'instructor_lead' || gameMode === 'instructor_initiated';
        if (isInstructorLeadOrInitiated) {
          $state.go('v1.instructor.game', { game_id: $scope.viewmodel.game_id });
        } else {
          $window.open(gameService.getGameUrl($scope.data.currentGame), '_blank');
        }
      },
      launchArcade() {
        $window.open(hubService.getHubUrl(hubService.currentHub()), '_blank');
      },
      v2route(...args) {
        singleSpaNavigate(`${URLprefix}/v2/${args.join('/')}`);
      },
    };

    const refreshSettings = $rootScope.$on('refreshSettings', () => {
      $scope.getSettings();
    });

    const newGamePopup = $rootScope.$on('newGamePopup', () => {
      $scope.actions.presentGame();
    });

    const stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
      if (!toParams.game_id) {
        gameService.clearGame();
      }
    });

    $scope.$on('$destroy', () => {
      refreshSettings();
      newGamePopup();
      stateChangeSuccess();
      angular.element($window).off('resize', resizeHandler);
    });

    $scope.initialize();
  },
]);
